export function Heart() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1518_15835)">
        <path
          d="M6.46154 0C5.81611 0.183894 4.80649 1.1899 4.06731 2.01923C3.51202 1.1899 2.30769 0.0865385 2.30769 0.0865385C2.30769 0.0865385 0.277644 -0.356971 0 1.67308C1.66226 3.33534 2.86659 5.16346 3.60577 6.54808C4.34495 6.08654 5.16346 5.82692 6.08654 5.82692H6.75C6.28846 4.9976 5.71154 4.15385 5.71154 4.15385C6.07933 3.59856 7.28005 2.48798 8.01923 1.93269C7.92548 1.19351 7.56851 0.367789 6.46154 0ZM15.6058 0C14.3149 0.0937505 13.2981 1.75962 13.2981 1.75962C13.2981 1.75962 14.0264 2.1238 14.3942 2.76923C13.9327 3.32452 13.5757 4.0601 13.2981 4.61539C14.405 4.61539 15.4038 4.79928 16.3269 5.07692L16.6154 4.52885C16.893 4.80649 17.0661 5.08774 17.25 5.36539C18.8185 5.92067 20.2103 6.93029 21.3173 8.22115C21.595 8.4988 21.7897 8.86659 22.0673 9.14423C20.8666 4.06731 17.0841 0.645433 15.6058 0ZM21.2308 0C20.2139 0.829327 19.3846 1.75962 19.3846 1.75962C19.3846 1.75962 20.5781 2.8738 21.3173 4.44231C21.3173 4.44231 22.893 2.94231 24 2.01923C23.6322 0.356971 22.4315 0 21.2308 0ZM13.0962 5.53846C10.6046 5.53846 9.14423 7.47115 9.14423 7.47115C9.14423 7.47115 7.65505 6.75 6.08654 6.75C3.6851 6.75 1.84615 9.3101 1.84615 13.0962C1.84615 19.9255 9.05769 21.7788 9.05769 21.7788C9.05769 21.7788 5.17067 16.8101 7.38462 12.2885C6.92308 17.4591 9.97356 21.5192 12.375 22.9038C15.3281 24.5661 19.9399 24.2668 23.0769 22.7885C23.2608 22.6947 23.7332 22.4243 23.8269 21.7788C24.4724 17.625 23.7115 5.53846 13.0962 5.53846Z"
          fill="#D0D3DC"
        />
      </g>
      <defs>
        <clipPath id="clip0_1518_15835">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
